import React from 'react';
import cn from 'classnames';

import { i18n } from '@lt/localization';
import { pluralizeYears } from 'src/utils/pluralizeUtils';
import ShowSavedTouristButton from '../ShowSavedTouristButton';
import TouristDocumentType from '../../DocumentType';

import type { DocType } from '../../types';
import { isChild } from '../../utils';
import styles from './touristsFormHeader.module.css';

type TouristsFormHeaderProps = {
  age: number;
  isMobile: boolean;
  docType: DocType;
  availableDocTypes: DocType[];
  handleDocTypeChange: (docType: string) => void;
  onTouristSelect: (touristsData: any) => void;
  showCustomerInfo: boolean;
};

const TouristsFormHeader = (props: TouristsFormHeaderProps) => {
  const {
    age,
    isMobile,
    docType,
    handleDocTypeChange,
    onTouristSelect,
    showCustomerInfo,
    availableDocTypes,
  } = props;
  return (
    <div
      className={cn(styles.container, styles.text, {
        [styles.mobileContainer]: isMobile,
      })}
    >
      <span>{`1 ${i18n.t('checkout.touristForm.room')}`}</span>
      <span> · </span>
      {isChild(age) ? (
        <span>
          {`${i18n.t('checkout.touristForm.child')}, ${age} ${pluralizeYears(
            age,
          )}`}
        </span>
      ) : (
        <span>{i18n.t('checkout.touristForm.adult')}</span>
      )}
      <span> · </span>
      <TouristDocumentType
        availableDocTypes={availableDocTypes}
        color="var(--black)"
        fontSize={14}
        fontStyle="normal"
        fontWeight={500}
        value={docType}
        onChange={handleDocTypeChange}
      />
      {showCustomerInfo && (
        <p className={styles.text}>
          <span> · </span>
          <span>{i18n.t('checkout.touristForm.customerInfo')}</span>
        </p>
      )}
      {isMobile && (
        <>
          <span> · </span>
          <ShowSavedTouristButton
            docType={docType}
            onClickOption={onTouristSelect}
          />
        </>
      )}
    </div>
  );
};

export default TouristsFormHeader;
